<template>
    <div class="fh">
        <div class="row fh">
            <div class="col-12 col-lg-8 col-xl-6">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col text-center d-none d-lg-block">
                            <img src="../assets/tplogo@1x.png" alt="Logo Theresa und Paul" />
                        </div>
                        <div class="col-12 col-xl-8 invite">
                            <p class="d-none d-lg-block invite-lg display-5">
                                <em>Wir haben „Ja“ gesagt und möchten das gemeinsam mit euch am Freitag, den 9. Oktober 2020 feiern.</em>
                            </p>

                            <div class="d-lg-none text-center fh">
                                <h1 class="display-5">Wir haben „Ja“ gesagt</h1>
                                <p class="lead">und möchten das gemeinsam mit euch am Freitag, den 9. Oktober 2020 feiern.</p>
                                <p class="align-text-bottom text-white-50 countdown">{{ countdown }}</p>
                            </div>
                        </div>                        
                    </div>

                    <div class="row justify-content-center updated d-none d-lg-flex">
                        <div class="col-6">
                            <div class="text-center">
                                Letzte Aktualisierung:<br>9. Oktober 2020<br><small>Die Feier findet statt :)</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-none d-lg-block col-lg-4 col-xl-6 fh">
                <div class="image-grid fh">
                    <div class="ig-row margin-bottom">
                        <div class="row no-gutters fh">
                            <div class="col-xl-7 col-12 ig-col">
                                <div class="image p1"></div>
                            </div>
                            <div class="d-none d-xl-block col-5 ig-col pl">
                                <div class="image p2"></div>
                            </div>
                        </div>
                    </div>
                    <div class="ig-row margin-bottom">
                        <div class="ig-col">
                            <div class="image p3"></div>
                        </div>
                    </div>
                    <div class="ig-row">
                        <div class="row no-gutters fh">
                            <div class="col-6 col-xl-2 ig-col">
                                <div class="image p4"></div>
                            </div>
                            <div class="col-6 col-xl-6 ig-col pl">
                                <div class="image p5"></div>
                            </div>
                            <div class="d-none d-xl-block col-4 ig-col pl">
                                <div class="image p6"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row justify-content-center updated d-lg-none">
            <div class="col-6 text-center">
                 <div class="text-center">
                     Letzte Aktualisierung:<br>9. Oktober 2020<br><small>Die Feier findet statt :)</small>
                 </div>
            </div>
        </div>

        <div class="d-lg-none">
            <a id="ablauf"></a>
            <h-ablauf />
            <h-infos />
        </div>
    </div>
</template>

<script>
import Ablauf from './Ablauf'
import Infos from './Infos'
import { DateTime, Interval } from 'luxon'

export default {
    name: 'home',
    components: {
        'h-ablauf': Ablauf,
        'h-infos': Infos
    },
    data() {
        return {
            countdown: ''
        }
    },
    beforeMount() {
        const _ = this
        
        setInterval(() => {
            const now = DateTime.local()
            const targetDate = DateTime.local(2020, 10, 9, 14, 0)
            const interval = Interval.fromDateTimes(now, targetDate)
            const duration = interval.toDuration(['days', 'hours', 'minutes', 'seconds']).toObject()

            if (interval.isValid) {
                const h = duration.hours ? duration.hours : 0
                const m = duration.minutes ? duration.minutes : 0
                const s = duration.seconds ? parseInt(duration.seconds) : 0

                //_.$data.countdown = `Noch ${duration.days} Tage ${duration.hours} Stunden ${duration.minutes} Minuten ${parseInt(duration.seconds)} Sekunden`
                if (h > 0) {
                    _.$data.countdown = `Noch ${h} Stunden ${m} Minuten ${s} Sekunden`
                } else {
                    _.$data.countdown = `Nur noch ${m} Minuten ${s} Sekunden :)`
                }
            } else {
                _.$data.countdown = ''
            }

        }, 1000);
    }
}
</script>

<style lang="scss">
@import '~bootstrap';

.image-grid {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-evenly;
    align-items: stretch;
    align-content: stretch;
}

.ig-row {
    flex: 1 0 auto;
}

.margin-bottom {
    margin-bottom: 1rem;
}

.pl {
    padding-left: 1rem !important;
}

.ig-col {
    height: 100%;
}

div.image {
    width: 100%;
    height: 100%;
    background-color: cadetblue;
}

.fh {
    height: 100%;
}

.p1 {
    background: url(../assets/m3_ji.jpg);
    background-size: cover;
}

.p2 {
    background: url(../assets/ff_12.jpg);
    background-size: cover;
}

@include media-breakpoint-only(lg) {
    .p3 {
        background: url(../assets/ff_12.jpg) bottom;
        background-size: cover;
    }

    .p5 {
        background: url(../assets/bw_z2.jpg);
        background-size: cover;
    }
}

@include media-breakpoint-only(xl) {
    .p3 {
        background: url(../assets/ol_63.jpg);
        background-size: cover;
    }

    .p5 {
        background: url(../assets/hm_j5.jpg);
        background-size: cover;
    }
}

.p4 {
    background: url(../assets/bild4.jpg) no-repeat center center fixed;
    background-size: cover;
}

.p6 {
    background: url(../assets/bw_z2.jpg);
    background-size: cover;
}

.invite-lg {
    margin-top: 2rem;
    border-top: rgba(0, 0, 0, 0.3) dotted 2px;
    border-bottom: rgba(0, 0, 0, 0.3) dotted 2px;
    padding: 1rem;
    text-align: center;
    font-size: 14pt !important;
}

@include media-breakpoint-down(md) {
    .invite {
        margin-top: 1rem;
        background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/bild3.jpg') no-repeat;
        background-position: bottom -50px right -100px;
        height: 26rem;
        padding: 3rem !important;

        & h1, & p {
            color: whitesmoke;
        }

        & .lead {
            padding-top: 7rem;
        }

        & .countdown {
            margin-top: 2rem;
        }
    }
}

.updated {

    & > div {
        padding-top: 2rem;

        & > div {
            padding: 0.2rem;
            border: 2px solid rgba(0, 0, 0, 0.5);
        }
    }
}
</style>
